module.exports = __webpack_public_path__ + "img/5.11ab29ed.jpeg";